import React from 'react';
export function sortChildren(children) {
  const unsorted = React.Children.toArray(children).map((item, i) => {
    var _props;
    let itemIndex = item === null || item === void 0 || (_props = item.props) === null || _props === void 0 ? void 0 : _props['data-item-index'];
    if (!isNaN(itemIndex) && itemIndex < 0) {
      itemIndex = children.length + itemIndex;
    }
    return {
      item,
      itemIndex,
      index: i
    };
  });
  const compare = (a, b) => {
    if (!isNaN(a.itemIndex) && !isNaN(b.itemIndex)) {
      return a.itemIndex - b.itemIndex;
    }

    /** itemIndex takes precedence over index */
    if (!isNaN(a.itemIndex)) {
      if (a.itemIndex - b.index === 0) {
        return -1;
      }
      return a.itemIndex - b.index;
    }
    if (!isNaN(b.itemIndex)) {
      if (a.index - b.itemIndex === 0) {
        return 1;
      }
      return a.index - b.itemIndex;
    }
    return a.index - b.index;
  };
  const sorted = unsorted.sort(compare);
  return sorted.map(_ref => {
    let {
      item
    } = _ref;
    return item;
  });
}

// @ts-expect-error can't resolve the type of children from the legacy function and provided React types
export const ItemInjector = /*#__PURE__*/React.memo(props => sortChildren(props.children));
//# sourceMappingURL=item-injector.react-component.js.map